export default {
  btnText: "Change company",
  popupTitle: "Company selection",

  pluralize: ["company", "companies"],

  modal: {
    totalCompanies: "Total: {amount}",
    searchPlaceholder: "Company search",
    viewByList: "List View",
    viewByCards: "Cards View",

    companyProfile: "Company profile",
    companyProfileFilled: "Completed",
    companyProfileNotFilled: "Not filled in",
    catalogApplication: "Publication in the Catalogue",
    catalogApplicationSent: "Sent",
    catalogApplicationNotSent: "Not sent",

    participantPasses: "Exhibitor passes",
    carPasses: "Parking pass"
  }
}
